import {
    Component,
    inject,
    ViewChild
} from '@angular/core';

import { $state } from 'app/ajs-upgraded-providers';

import {
    CustomerFe,
    DataExport,
    QueryPagination,
    RowModelType,
    TableData,
    TableRowUpdatable
} from 'src/app/shared/model/model';

import {
    IServerSideDatasource,
    RowClickedEvent,
} from "ag-grid-community";

import {
    from,
    Subject
} from "rxjs";

import {
    Rest,
    TilbyToolbar
} from "src/app/models";

import { ToolbarEventsService } from "src/app/core/services/toolbar-events/toolbar-events.service";

import {
    ConfirmDialogService,
    GridDownloadDialogService,
    OpenDialogsService
} from "src/app/dialogs";

import { autobind } from "src/app/models/decorators.model";
import { GridServerSideComponent } from "src/app/shared/components/grid-server-side/grid-server-side.component";

import {
    headersTranslate,
    ImplementServerSideGrid
} from "src/app/shared/components/grid";

import { GridService } from "src/app/shared/components/grid/grid.service";
import { GridCellFormatterService } from 'src/app/shared/components/grid/utils/grid-cell-formatter.service';
import { EntityManagerService } from "src/app/core/services/entity/entity-manager.service";
import { GridCellExportFormatterService } from 'src/app/shared/components/grid/utils/grid-cell-export-formatter.service';

import {
    ConfigurationManagerService,
    ConnectionService,
    PaginatedResponse
} from 'src/app/core/services';

import {
    CustomersFields,
    CustomersFormGroups
} from "../customers-details";

import { CustomerFormService } from "../../services";
import { callbackToGrid } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { Transition } from 'angular-ui-router';
import { Customers } from 'tilby-models';
import { subscribeInComponent } from "src/app/shared/angular-utils";

const customField = [['custom_field_1','custom_1'], ['custom_field_2','custom_2'], ['custom_field_3','custom_3'],['custom_field_4','custom_4'],['custom_field_5','custom_5'],['custom_field_6','custom_6'],['custom_field_7','custom_7'],['custom_field_8','custom_8'],['custom_field_9','custom_9']];

@Component({
	standalone: false,
    selector: 'app-customers-showcase',
    templateUrl: './customers-showcase.component.html',
    styleUrls: ['./customers-showcase.component.scss'],
    providers: [
        CustomerFormService
    ]
})
export class CustomersShowcaseComponent implements TilbyToolbar, ImplementServerSideGrid{
    private readonly entityManager = inject(EntityManagerService);
    private readonly gridService = inject(GridService);
    private readonly configurationManagerService = inject(ConfigurationManagerService);
    private readonly confirmDialogService = inject(ConfirmDialogService);
    private readonly state = inject($state);
    private readonly toolbarEventsService = inject(ToolbarEventsService);
    private readonly openDialogsService = inject(OpenDialogsService);
    private readonly gridCellFormatterService = inject(GridCellFormatterService);
    private readonly gridCellExportFormatterService = inject(GridCellExportFormatterService);
    private readonly customerFormService= inject(CustomerFormService);
    private readonly connection = inject(ConnectionService);
    private readonly gridDownloadDialogService = inject(GridDownloadDialogService);

    rowModelType: RowModelType = "serverSide";
    isSelected = false;
    gridPath = this.state.$current.name.split('.').pop() === 'customers';
    gridReady$ = new Subject();

    @ViewChild('appGridComponent', {static: true}) gridRef!: GridServerSideComponent;

    exportFormatterOptions?: (...any:any[])=>any;

    readonly query: Readonly<QueryPagination> = {
        pagination: true,
        per_page: 30,
        page: 0,
    };

    value = "";

    tableData: TableData[] = [
        {
            rowData$: null,
            dataType: this.updateCustomField(new CustomerFe()),
            headersTranslate: headersTranslate.customers_showcase,
            columnsFormatter: this.gridCellFormatterService.customers
            // columnsExcelFormatter: this.gridCellExportStyleService.customers
        }
    ];
    datasource: IServerSideDatasource = {
        getRows: (params) => this.gridRef.getRowsForServersideDatasource(params,[this.query],(a,b?)=>from(this.entityManager.customers.fetchCollectionOnline(a) as Promise<PaginatedResponse<Customers>>),{sort_type:"asc",sort_col:"last_name"})
    };
    //-------- NEW GENERIC TOOLBAR - START ----///

    private updateCustomField(customerFe: CustomerFe): any {
        customField.forEach((element) => {
            if (!this.configurationManagerService.getSetting('customers.' + element[0] as any)) {
                // @ts-ignore
                delete customerFe[element[1]]
            }
        });
        return customerFe;
    }

    private movColumnsSwitch = false;
    private isAdvancedFilterActive = false;

    constructor() {
        this.state.router.transitionService.onSuccess({}, (transition: Transition&any) => this.gridPath = transition._targetState._identifier.split('.').pop() === 'customers');

        subscribeInComponent(this.toolbarEventsService.events, (event) => {
            switch(event.type) {
                case 'toolbar.search':
                    return this.gridRef.onFilterTextBoxChanged(event.search);
                case 'grid.open_tool_panel':
                    return this.gridRef.openToolPanel(event.panel);
            }
        });
    }

    ngOnInit() {
        // first time
        this.createToolbarButtons();
        this.setModuleTitle();
        // on show again
        this.state.router.transitionService.onSuccess({to: 'app.new.customers'}, (transition: Transition) => {
            if(!!transition.params().remove) this.gridRef.onRemoveSelected(transition.params().remove);
            this.createToolbarButtons();
        });
        this.toolbarEventsService.searchBarValue$.next('');
        this.toolbarEventsService.searchBarIcon$.next('tune');
        this.toolbarEventsService.searchBarIconFilled$.next('tune');
        this.toolbarEventsService.searchBarAction$.next({ type: 'grid.open_tool_panel', panel: 'filters' });
        this.toolbarEventsService.searchBarActionFilled$.next({ type: 'grid.open_tool_panel', panel: 'filters' });
        this.exportFormatterOptions = this.gridCellExportFormatterService.customerExportFormatter;
    }

    setModuleTitle() {
        this.toolbarEventsService.moduleTitle.next("CUSTOMERS");
    }

    async openDeleteDialog() {
        const res = await this.confirmDialogService.openDialog({
            data: {
                messageLabel: 'DIALOG.CUSTOMER_DELETE.TITLE',
                confirmLabel: 'APPLICATION.YES',
                cancelLabel: 'APPLICATION.NO'
            }
        });

        if(res) {
            this.gridRef.onRemoveSelected();
        }
    }

    /**
     * Create buttons for the toolbar
     */
    createToolbarButtons() {
        this.toolbarEventsService.buttons$.next({
            barButtons: [
                {
                    isIt: () => this.connection.isOffline(),
                    name: 'cloud_off',
                    icon: () => 'cloud_off',
                    click: () => null
                },
                {
                    isIt: () => true,
                    name: 'add_new_customer',
                    icon: () => 'playlist_add',
                    click: () => this.state.go("app.new.customers.new")
                },
                {
                    isIt: () => this.isSelected,
                    name: 'edit',
                    icon: () => 'edit',
                    click: () => {
                        this.openDialogsService.openEditRowsDialog<CustomersFields, CustomersFormGroups>({
                            data: { form: this.customerFormService.createForm() }
                        }).then((res) => !!res && this.gridRef.updateItems(callbackToGrid(res)));
                    }
                },
                {
                    isIt: () => this.isSelected,
                    name: 'delete',
                    icon: () => 'delete',
                    click: () => this.openDeleteDialog()
                }
            ],
            panelButtons: [
                {
                    isIt: () => true,
                    name: 'columns_panel',
                    icon: () => 'view_week',
                    label: () => 'TOPBAR.ACTIONS.COLUMN_SELECTED',
                    click: () => this.gridRef.openToolPanel('columns')
                },
                {
                    isIt: () => true,
                    name: 'movable_columns',
                    icon: () => 'drag_indicator',
                    label: () => this.movColumnsSwitch ? 'TOPBAR.ACTIONS.DISABLED_COLUMN_MOVEMENT': 'TOPBAR.ACTIONS.ENABLED_COLUMN_MOVEMENT',
                    click: () => this.gridRef.columnMovableSwitch(this.movColumnsSwitch = !this.movColumnsSwitch)
                },
                {
                    isIt: () => true,
                    name: 'save_columns_position',
                    icon: () => 'save',
                    label: () => 'TOPBAR.ACTIONS.SAVE_COLUMN_PREFERENCE',
                    click: () => this.gridRef.openDialogSaveColumnsPreference()
                },
                {
                    isIt: () => true,
                    name: 'advanced_filter',
                    icon: () => this.isAdvancedFilterActive ? 'filter_alt_off' : 'filter_list_alt',
                    label: () => this.isAdvancedFilterActive ? 'TOPBAR.ACTIONS.ADVANCED_FILTERS_DISABLED' : 'TOPBAR.ACTIONS.ADVANCED_FILTERS_ENABLED',
                    click: () => this.gridRef.advancedFilterSwitch(this.isAdvancedFilterActive = !this.isAdvancedFilterActive)
                },
                {
                    isIt: () => true,
                    name: 'upload',
                    icon: () => 'upload',
                    label: () => 'TOPBAR.ACTIONS.IMPORT',
                    click: () => this.goToImporter()
                },
                {
                    isIt: () => true,
                    name: 'export',
                    icon: () => 'download',
                    label: () => 'TOPBAR.ACTIONS.EXPORT',
                    click: async () => {
                        const res = await this.gridDownloadDialogService.openDialog('customers', {
                            data: this.tableData.map(tableData => ({
                                ...tableData,
                                sortFilterQuery: this.gridRef.getSortFilterQuery(),
                                countSelectedRows: this.gridRef.gridApi?.getSelectedRows().length
                            }))
                        });

                        if (res) {
                            this.onExport(res);
                        }
                    }
                },
            ]
        });
    }

    goToImporter() {
        this.state.go('app.new.file_importer');
    }

//-------- NEW GENERIC TOOLBAR - END ----///



    @autobind
    onExport(dataExport: DataExport) {
        this.gridRef?.onBtnExport(dataExport)
    }

    addCustomer() {
        this.state.go("app.customers.new");
    };



    rowClicked({data}: RowClickedEvent) {
        this.movColumnsSwitch && this.gridRef.columnMovableSwitch(this.movColumnsSwitch = false);
        this.state.go(`app.new.customers.details`, {customerId: data.id});
    }

    @autobind
    updateItems(updatedRows: TableRowUpdatable[]) {
        updatedRows.forEach(updatedRow => this.entityManager.customers.putOneOnline(updatedRow as any).then(() => this.gridRef?.agGrid.api.refreshServerSide({ purge: false })));
    }

    deleteCustomers(ids: number[]) {
        ids.forEach(id => this.entityManager.customers.deleteOneOnline(id).then(() => { this.gridRef.agGrid.api.refreshServerSide({purge: false}); }).then(() => this.gridService.tableProperties.idsDeleting = []));
    }

    crud({method, id}: Rest) {
        if (method === 'delete') {
            this.gridRef.onRemoveSelected(id);
        }
    }
}
